import { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'

type BaseFormFieldProps = {
  label: string
  error?: string
}

type InputFormFieldProps = BaseFormFieldProps & {
  textarea?: false
} & InputHTMLAttributes<HTMLInputElement>

type TextareaFormFieldProps = BaseFormFieldProps & {
  textarea: true
} & TextareaHTMLAttributes<HTMLTextAreaElement>

type FormFieldProps = InputFormFieldProps | TextareaFormFieldProps

function FormField({ label, error, textarea, ...props }: FormFieldProps) {
  const InputComponent = textarea ? 'textarea' : 'input'

  return (
    <div className="form-field">
      <label htmlFor={props.id}>
        {label}
        {props.required && <span className="required">*</span>}
      </label>
      <InputComponent {...props as any} className={error ? 'error' : ''} />
      {error && <span className="field-error">{error}</span>}
    </div>
  )
}

export default FormField
